<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <SoftButton
                    data-bs-toggle="modal"
                    data-bs-target="#newuser"
                    class="mt-2 mb-0 btn bg-gradient-primary ms-lg-3 me-lg-0 me-auto mt-lg-0 ">
                    <i class="fa fa-plus-circle me-2" aria-hidden="true"></i>
                    {{ $t('key_button_add_user') }}
                  </SoftButton>
                  <!-- Interactions with database (filters and reload) -->
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <ReloadButton :title="$t('key_userListTableHeader_button_reload_user')" @change="getUsers"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!userData"
            ref="genericTable"
            :items="userData.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="user">
              <td class="font-weight-bold" style="width: 40rem">
                <span class="my-2 text-xs">{{ user.user }}</span>
              </td>
              <td class="font-weight-bold" style="width: 40rem">
                <span class="my-2 text-xs">{{ userRole(user) }}</span>
              </td>
              <td class="font-weight-bold" style="width: 40rem">
                <span class="my-2 text-xs">{{ $dateUtils.toDDMMYYYYHH(user.createdAt) }}</span>
              </td>
              <td class="font-weight-bold" style="width: 20rem">
                <span v-if="user.status!='NO_ACTIVED'" class="badge badge-enabled badge-sm">{{ this.$t('key_user_enabled') }}</span>
                <span v-else class="badge badge-disabled badge-sm">{{ this.$t('key_user_disabled') }}</span>
              </td>
              <td class="text-xs font-weight-bold">
                <a
                  style="cursor:pointer"
                  class="mx-3"
                  :title="user.status == 'ACTIVED' ? $t('key_user_disableUser') : $t('key_user_enableUser')"
                  data-bs-toggle="modal"
                  data-bs-target="#userStatusModal"
                  @click="userStatusModalData = { ...user }">
                  <i :class="{ 'fa-solid fa-user text-disabled': user.status == 'ACTIVED', 'fa-solid fa-user text-enabled': user.status == 'NO_ACTIVED' }"></i>
                </a>
                <a
                  style="cursor:pointer"
                  class="mx-3"
                  :title="$t('key_user_deleteUser')"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteUserModal"
                  @click="userToDelete = { ...user} ">
                  <i class="fa-solid fa-trash-can text-danger"></i>
                </a>  
              </td>
            </template>
          </GenericTable>

        </div>
      </div>
    </div>
  </div>
  <ModalNewUser />
  <ModalUserStatus :user-status-modal-data='userStatusModalData' @confirm-user-status="confirmUserStatus" />
  <ModalDeleteConfirmation :entity='userToDelete' @confirm-delete="deleteUser" />
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>

</template>

<script>

  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import Filter from "./components/Filter.vue";
  import ModalNewUser from "./components/ModalNewUser.vue";
  import ModalUserStatus from "@/components/ModalUserStatus.vue";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import ModalDeleteConfirmation from "./components/ModalDeleteConfirmation.vue";

  export default {
    name: "UserList",
    components: {
      SoftButton,
      ModalNewUser,
      ModalUserStatus,
      SoftSnackbar,
      GenericTable,
      ReloadButton,
      Searchbox,
      Filter,
      ModalDeleteConfirmation
    },
    data()  {
      return{
        filterStatusSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        showErrorNotification: false,
        showSuccessNotification: false,
        errorDescription: "",
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        isLoading: false,
        showNotification: false,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          }
        },
        userStatusModalData: {},
        userToDelete: {}
      }
    },
    computed: {
      userData() {
        return this.$store.state.user.userLists.data;
      },
      newUsuario() {
        return this.$store.state.user.newUser.status;
      },
      listFilters() {
        return this.$store.state.user.listFilters;
      },
      deleteUserStatus() {
        return this.$store.state.user.deleteUser.status;
      },
      userStatus() {
        return this.$store.state.user.userStatus.status;
      },
      headers() {
        return [
            { title: this.$t('key_theader_user'), sort: { sorteable: true, order: "" }, column: "user" },
            { title: this.$t('key_theader_UserList_role'), sort: { sorteable: true, order: "" }, column: "roles" },
            { title: this.$t('key_theader_createdat'), sort: { sorteable: true, order: "" }, column: "createdAt" },
            { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" },
            { title: this.$t('key_theader_UserList_actions'), sort: { sorteable: false, order: ''} }
        ];
      },
      title() {
        return this.$t('key_userList_table_title');
      },
      description() {
        return this.$t('key_userList_table_description');
      }
    },
    watch: {
      userStatus(val) {
        if (val.userStatus) {
          if (this.$store.state.user.userStatus.data) {
            this.notificationInfo = {
              title: this.userStatusModalData.status == 'ACTIVED' ? this.$t('key_mheader_user_disabled') : this.$t('key_mheader_user_enabled'),
              message: this.userStatusModalData.status == 'ACTIVED' ? this.$t('key_mmessage_user_disabled') : this.$t('key_mmessage_user_enabled'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotifications()
            setTimeout(() => {
              this.getUsers();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error,
            status: 'error'
          }
          this.closeNotifications()
        }
      },
      deleteUserStatus(newValue) {
        if(newValue['deleted']){
          this.notificationInfo = {
            title: this.$t('key_user_successfully_deleted'),
            message: this.$t('key_user_successfully_deleted_message'),
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotifications();
          setTimeout(() => {
              this.getUsers();
            }, 200);
        }

        if(newValue['error']){
          this.notificationInfo = {
            title: 'Ups! Lo Sentimos',
            message: newValue.error,
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotifications();
        }
      },
      userData() {
        if(this.userData){
          this.pagination.total= this.userData.total;
          this.isLoading = false;
        }
      },
      newUsuario(val) {
        if (val.created) {
          if (this.$store.state.user.newUser.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_user_created'),
              message: this.$t('key_mmessage_user_created'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotifications()
            setTimeout(() => {
              this.getUsers();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: this.$t('key_mheader_user_error'),
            message: val.error.error,
            status: 'error'
          }
          this.closeNotifications()
        }
      },
    },
    mounted() {
      this.setUpFilters()
      this.getUsers();
    },
    methods: {
      userRole(user) {
        const roles = user.roles;
        const rol = roles.find(role => role !== 'CUSTOMER');

        if (rol === 'ADMIN') {
          return this.$t('key_user_role_admin')
        } else {
          return this.$t('key_user_role_user')
        }
      },
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      getUsers() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("user/getUsers",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getUsers();
      },
      onFilterChange(value){
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getUsers(); 
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getUsers(); 
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getUsers(); 
      },
      closeNotifications() { 
        setTimeout(() => {
          this.showNotification = false
        }, 4000);
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getUsers(); 
      },
      confirmUserStatus(data){
        this.$store.commit("user/userStatus", data);
      },
      deleteUser(value) {
        this.$store.commit("user/deleteUser", value);
      },
    }
  };

</script>

<style scoped>

  .columns {
    max-width: 150px;
  }

</style>